import React from 'react'
import QRCode from 'qrcode';

class QRCodeView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate(prevProps) {
    // 檢查deepLink是否有變化
    if (this.props.deepLink !== prevProps.deepLink) {
      this.generateQRCode();
    }
  }

  componentDidMount() {
    this.generateQRCode();
  }

  componentWillUnmount() {

  }

  generateQRCode() {
    const { deepLink = 'aa' } = this.props;
    setTimeout(() => {
      if (deepLink && document.getElementById('qrcode')) {
        const opts = {
          errorCorrectionLevel: 'H',
          type: 'image/jpeg',
          rendererOpts: { quality: 0.3 }
        };
        QRCode.toDataURL(deepLink, opts, function (err, url) {
          if (err) throw err;
          var img = document.getElementById('qrcode');
          img.src = url;
        });
      }
    }, 500);
  }


  render() {
    return (
      <>
        <img id='qrcode' alt="qrcode"/>
      </>
    );
  }
}

export default QRCodeView;
